import io, { Socket } from 'socket.io-client';
import { ref, watch, onUnmounted } from 'vue';
import { useAuthStore } from '@/store/auth/authModule';

const socket = ref<Socket | null>(null);
const connected = ref(false);

let pingInterval: number | null = null;

export function useSocket() {
  const authStore = useAuthStore();

  const startPing = () => {
    if (pingInterval) return;

    pingInterval = window.setInterval(() => {
      if (socket.value?.connected) {
        socket.value.emit('ping', { ts: Date.now() });
      }
    }, 15000);
  };

  const stopPing = () => {
    if (pingInterval) {
      clearInterval(pingInterval);
      pingInterval = null;
    }
  };

  const emitAuth = () => {
    socket.value?.emit('auth', {
      Name_app: 'SmartPRO',
      id_login: authStore.user?.id_login,
    });
  };

  const createSocket = () => {
    if (socket.value) return;

    socket.value = io('https://host2.medsafe.tech:51510', {
      path: '/interconnect',
      transports: ['websocket', 'polling'],
      reconnection: true,
      reconnectionAttempts: Infinity,
      reconnectionDelay: 1000,
      reconnectionDelayMax: 5000,
      timeout: 10000,
      autoConnect: false,
    });

    socket.value.on('connect', () => {
      connected.value = true;
      console.info('[socket] connected:', socket.value?.id);
      emitAuth();
      // startPing();
    });

    socket.value.on('disconnect', (reason: any) => {
      connected.value = false;
      console.warn('[socket] disconnected:', reason);
      // stopPing();
    });

    socket.value.on('reconnect', (attempt: any) => {
      console.info('[socket] reconnected, attempt:', attempt);
    });

    socket.value.on('connect_error', (err: any) => {
      console.error('[socket] connect_error:', err.message);
    });

    socket.value.on('error', (err: any) => {
      console.error('[socket] error event:', err);
    });

    socket.value.io.on('error', (err: any) => {
      console.error('[socket] io error:', err);
    });

    socket.value.io.on('patient-created', (context: any) => {
      console.error('[socket] patient-created:', context);
    });

    socket.value.io.on('external-exit', (context: any) => {
      console.error('[socket] external-exit:', context);
      useAuthStore().logout();
    });
  };

  const destroySocket = () => {
    stopPing();

    if (socket.value) {
      socket.value.disconnect();
      socket.value.removeAllListeners();
      socket.value = null;
    }

    connected.value = false;
  };

  watch(
    () => authStore.isAuth,
    (isAuth) => {
      if (isAuth) {
        createSocket();

        if (!socket.value) return;

        socket.value.auth = {
          Name_app: 'SmartPRO',
          id_login: authStore.user?.id_login,
        };
        socket.value?.connect();
      } else {
        destroySocket();
      }
    },
    { immediate: true },
  );

  onUnmounted(() => {

  });

  const on = (event: string, callback: (...args: any[]) => void) => {
    socket.value?.on(event, callback);
    return () => socket.value?.off(event, callback);
  };

  return {
    socket,
    connected,
    emit: (event: string, payload?: any) => socket.value?.emit(event, payload),

    on,
  };
}
